import React from 'react';
import styled from '@emotion/styled';
import { __ } from '../../helpers/TranslationService';
import { Button } from '../Button/Button';
import { CrossIcon } from '../Icons/CrossIcon';

interface NewsletterSuccessScreenProps {
    className?: string;
    enableCatalogueSignUp: boolean;
    onBannerCloseHandler: () => void;
}

const Container = styled.div``;

const Header = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid ${(props) => props.theme.border.onBg};

    *:last-child {
        margin-left: auto;
    }
`;

const HeaderTitle = styled.p`
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    margin: 0 8px;
`;

const Body = styled.div`
    background: ${(props) => props.theme.background.page};
    display: flex;
    flex-direction: column;
    padding: 16px;

    p {
        font-size: 14px;
        line-height: 22px;
        margin: 0 0 8px 0;
    }
`;

export const NewsletterSuccessScreen: React.FC<NewsletterSuccessScreenProps> = ({
    className,
    enableCatalogueSignUp,
    onBannerCloseHandler,
}) => {
    return (
        <Container className={className}>
            <Header>
                <HeaderTitle>
                    {__('Thank you! Your registration was successful!', 'dreamlines')}
                </HeaderTitle>

                <Button
                    paddings={false}
                    rounded={false}
                    color="flatSecondary"
                    size="small"
                    onClick={onBannerCloseHandler}
                >
                    <CrossIcon
                        style={{
                            width: '16px',
                            height: '16px',
                        }}
                    />
                </Button>
            </Header>
            <Body>
                {enableCatalogueSignUp && (
                    <p>
                        <b>{__('wantToGetCatalog', 'dreamlines')}</b>
                    </p>
                )}

                <p>
                    {__(
                        'you are just one step away from getting all top offers: Please go to your E-Mail provider and verify your E-Mail address.',
                        'dreamlines',
                    )}
                </p>

                {enableCatalogueSignUp ? (
                    <Button as={'a'} href={__('brochureLink', 'dreamlines')} fullWidth>
                        {__('SignUpForFree', 'dreamlines')}
                    </Button>
                ) : (
                    <Button fullWidth size="large" color="primary" onClick={onBannerCloseHandler}>
                        {__('Close', 'dreamlines')}
                    </Button>
                )}
            </Body>
        </Container>
    );
};
